import { useState, useRef, useEffect } from 'react';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function useFixedCardMenu(props) {
    const { containerRef = null, offsetY = 0, offsetX = 0 } = props ?? { containerRef: null, offsetY: 0, offsetX: 0 };
    
    const menuRef = useRef(null);
    const [showMenu, setShowMenu] = useState({ flag: false });
    const [menuCoordinates, setMenuCoordinates] = useState({ x: 0, y: 0 });

    useOutsideClick(menuRef, () => {
        if (showMenu.flag) {
            setShowMenu({ flag: false });
        }
    });

    function toggleShowMenu(e) {
        setShowMenu({ flag: false });
    }

    useEffect(() => {
        if (showMenu.flag) {
            window.addEventListener('scroll', toggleShowMenu);
            containerRef?.current && containerRef.current.addEventListener('scroll', toggleShowMenu);
        } else {
            window.removeEventListener('scroll', toggleShowMenu);
            containerRef?.current && containerRef.current.removeEventListener('scroll', toggleShowMenu);
        }

        return () => {
            window.removeEventListener('scroll', toggleShowMenu);
            containerRef?.current && containerRef.current.removeEventListener('scroll', toggleShowMenu);
        };
    }, [showMenu.flag])


    const onOpenMenu = (props = {}) => {
        const { id = null, event, ...args } = props;
        event?.stopPropagation();
        if (!id) {
            setShowMenu({});
            return;
        }
        setShowMenu({
            id,
            flag: true,
            ...args,
        });
        let transform = '';
        if (containerRef) {
            const targetRect = event.currentTarget.getBoundingClientRect();
            const containerRect = containerRef?.current?.getBoundingClientRect();
            let left = targetRect.left - containerRect.left + targetRect.height + 10;
            if (left + offsetX + containerRect.left > window.innerWidth) {
                transform = 'translateX(-100%)';
            }
            let top = targetRect.top - containerRect.top + targetRect.height + 10;
            if (top + offsetY + containerRect.top > window.innerHeight) {
                transform = `${transform} translateY(-100%)`;
            }
            setMenuCoordinates({ left, top, transform });
        } else {
            setMenuCoordinates({ x: event.clientX, y: event.clientY });
        }
    };

    return { menuRef, showMenu, menuCoordinates, onOpenMenu, toggleShowMenu };
}
